import React from 'react';
import ReactDOM from 'react-dom/client';
import { TamaguiProvider, Theme } from 'tamagui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import config from '../tamagui.config';
import App from './App';
import { useThemeStore } from './lib/theme-store';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
});

/**
 * Drives both Tamagui's active theme and the document background from the
 * persisted theme store, so light/dark applies app-wide (including the area
 * behind portals/overlays).
 */
function ThemedApp() {
  const mode = useThemeStore((s) => s.mode);
  React.useEffect(() => {
    document.documentElement.style.colorScheme = mode;
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);
  return (
    <TamaguiProvider config={config} defaultTheme={mode}>
      <Theme name={mode}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </Theme>
    </TamaguiProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemedApp />
  </React.StrictMode>,
);
